module.exports = __webpack_public_path__ + "img/approve-list21.85e5fb7e.png";